import { useAuthStore } from '../../store/AuthStore';
import { ROLES } from '../../utils/roleUtils';

// Component to check if user has access based on roles
export const RoleBasedAccess = ({
  children,
  allowedRoles = [],
  fallback = null,
}) => {
  const { user } = useAuthStore();

  if (!user || !user.role) {
    return fallback;
  }

  const hasAccess =
    allowedRoles.length === 0 || allowedRoles.includes(user.role);

  return hasAccess ? children : fallback;
};

// Component to hide content from superAdmin users
export const HideFromSuperAdmin = ({ children, fallback = null }) => {
  const { user } = useAuthStore();

  if (user && user.role === ROLES.SUPER_ADMIN) {
    return fallback;
  }

  return children;
};

export default RoleBasedAccess;
